import React, { useEffect } from 'react';
import { FormViewContent } from 'components/FormViewContent';
import { BoolToString, CTSUCardActions } from 'components';
import { RenderEditable, RenderElement } from 'components/RenderHelpers';
import { withAppContext } from '@ctsu/loader';
import { compose, withState, withHandlers } from 'recompose';
import { MUISelect, ValidatorForm } from 'components/FormHelpers/FormInputs';
import { ListItem, ListItemText } from '@material-ui/core';
import { openSnackbar } from 'helpers/Notifier';
import { httpStatusEnum } from 'appconstants';
import atoms from 'ctsutheme/components/atoms';
import { openConfirmation } from 'helpers/Confirmation';
import { withStyles } from '@material-ui/core/styles';
import { GetFromCtxValue } from 'helpers';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { bindLogger } from 'helpers/BindLogger';
import PropTypes from 'prop-types';
import { saveCollectIrbApproval } from 'actions/protocols/protocoldetail';
import { CanUserEditStatusChange } from 'appconstants/Permission';
import { IrbExemptSelector } from 'selectors';

const { Divider } = atoms;

const styles = theme => ({
  editable: {
    // width: 70
  }
});

const CollectIRBPostClosure = ({
  collectIrbApprovalPostClosure,
  state,
  setState,
  setData,
  data,
  handleChange,
  clearStatusCb,
  closeStatusCb,
  saveStatusCb,
  classes,
  isIrbExempt
}) => {
  useEffect(() => {
    if (state) {
      setData({
        collectIrbApprovalPostClosure
      });
    }
  }, [state, setData, collectIrbApprovalPostClosure]);
  return (
    <RenderEditable
      state={state}
      editable={CanUserEditStatusChange() && !isIrbExempt}
      setState={setState}
      title="Collect IRB approvals post closure to accrual"
    >
      <RenderElement access={state === false}>
        <FormViewContent
          name="collectIrbApprovalPostClosure"
          primaryText="Collect IRB approvals post closure to accrual?"
          secondaryText={<BoolToString boolValue={collectIrbApprovalPostClosure} />}
        />
      </RenderElement>
      <RenderElement access={state === true}>
        <ValidatorForm onSubmit={saveStatusCb}>
          <FormViewContent
            primaryText="Collect IRB approvals post closure to accrual?"
            secondaryText={(
              <MUISelect
                name="collectIrbApprovalPostClosure"
                value={data.collectIrbApprovalPostClosure}
                onChange={handleChange}
                className={classes.editable}
              >
                <ListItem button value>
                  <ListItemText primary="Yes" />
                </ListItem>
                <ListItem button value={false}>
                  <ListItemText primary="No" />
                </ListItem>
              </MUISelect>
            )}
          />
          <Divider />
          <CTSUCardActions
            clearClick={clearStatusCb}
            cancelClick={closeStatusCb}
            disabled={data.collectIrbApprovalPostClosure === collectIrbApprovalPostClosure}
          />
        </ValidatorForm>
      </RenderElement>
    </RenderEditable>
  );
};


CollectIRBPostClosure.propTypes = {
  collectIrbApprovalPostClosure: PropTypes.bool,
  state: PropTypes.bool,
  setState: PropTypes.func,
  setData: PropTypes.func,
  data: PropTypes.oneOfType([PropTypes.object]),
  handleChange: PropTypes.func,
  clearStatusCb: PropTypes.func,
  closeStatusCb: PropTypes.func,
  saveStatusCb: PropTypes.func,
  classes: PropTypes.oneOfType([PropTypes.object])
};

CollectIRBPostClosure.defaultProps = {
  collectIrbApprovalPostClosure: null,
  state: false,
  setState: null,
  setData: null,
  data: null,
  handleChange: null,
  clearStatusCb: null,
  closeStatusCb: null,
  saveStatusCb: null,
  classes: null
};

const withConnectState = connect(
  (state, ownProps) => ({
    prtInfo: state.prtDetails.prtInfo,
    isIrbExempt: IrbExemptSelector(state)
  }),
  dispatch => bindActionCreators(
    {
      onSaveCollectIrbApproval: saveCollectIrbApproval
    },
    dispatch
  )
);

export default withStyles(styles)(compose(
  withConnectState,
  withAppContext,
  withState('state', 'setState', false),
  withState('data', 'setData', {}),
  withHandlers({
    closeStatusCb: props => event => {
      const { setState, state } = props;
      setState(!state);
    }
  }),
  withHandlers({
    handleChange: props => event => {
      const { data, setData } = props;
      setData({ ...data, [event.target.name]: event.target.value });
    },
    clearStatusCb: props => event => {
      const { setData, collectIrbApprovalPostClosure } = props;
      setData({ collectIrbApprovalPostClosure });
    },
    saveStatusCb: props => event => {
      const {
        context,
        onSaveCollectIrbApproval,
        data,
        prtInfo,
        closeStatusCb
      } = props;
      const confirmEdit = () => {
        bindLogger(onSaveCollectIrbApproval, context)(data, prtInfo.prtId).subscribe(
          resp => {
            if (resp.status === httpStatusEnum.SUCCESS) {
              openSnackbar({
                message: GetFromCtxValue(context, 'PROTOCOL_COLLECT_IRB_SUCCESS'),
                variant: 'success',
                name: 'collect_irb'
              });
              closeStatusCb();
            }
          },
          err => {}
        );
      };
      openConfirmation({
        message: GetFromCtxValue(context, 'PROTOCOL_COLLECT_IRB_CONFIMATION'),
        onAction: confirmEdit,
        name: 'collect_irb'
      });
    }
  })
)(CollectIRBPostClosure));
